module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_05a.0fdc01f1.jpg";